import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var dropDownStyle = function dropDownStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6,
    primary1 = _getThemeData.primary1;
  return css(["li[class*='-disabled']{&.ant-dropdown-menu-item.ant-dropdown-menu-item:hover,.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title:hover{background-color:#fff;}}li:not([class*='-disabled']){&.ant-dropdown-menu-item.ant-dropdown-menu-item:hover,.ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title:hover{background-color:", ";color:", ";a,i,i:after{color:", ";}}}"], primary1, primary6, primary6);
};
export default dropDownStyle;